import getApiInstance from '@/api';
import type { BookingDTO } from '@/types/dto/agent';
import type { Voucher } from '@/types/purchase';
import { mapBookingVoucherPaymentsToVouchers } from '@/utils/booking';
import { useCallback, useEffect, useState } from 'react';

interface useUsedVouchersProps {
  bookingId: BookingDTO['id'];
}

const useUsedVouchers = ({ bookingId }: useUsedVouchersProps) => {
  const [usedVouchers, setUsedVouchers] = useState<Array<Voucher>>([]);

  const getUsedVouchers = useCallback(async (bookingId: string) => {
    if (!bookingId) {
      return;
    }

    const api = (await getApiInstance()).agentApi;

    const bookingPayments =
      (await api.Payments_GetBookingPayments({ bookingId })).data.items || [];
    const voucherPayments = bookingPayments.filter(
      (payment) => payment.type?.id === 'VOUCHER'
    );

    const preparedVouchers =
      mapBookingVoucherPaymentsToVouchers(voucherPayments);
    setUsedVouchers(preparedVouchers);
  }, []);

  useEffect(() => {
    if (bookingId) {
      getUsedVouchers(bookingId);
    }
  }, [bookingId, getUsedVouchers]);

  return usedVouchers;
};

export default useUsedVouchers;
